import React from 'react';
import {
  Button,
  FormControl,
  Grid,
  InputLabel,
  Select
} from '@material-ui/core';
import * as PropTypes from "prop-types";
import { withStyles } from "@material-ui/styles";
import saveAs from 'file-saver';
import { DateRangePicker } from "react-dates";
import _ from 'lodash';

import MomentUtils from "@date-io/moment";
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import { theme } from '../../../config';
import {
  ArrowBack,
  ArrowForward, GetApp,
  Timeline
} from "@material-ui/icons";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import { returnDescriptiveDate, round } from "../../../utils";
import CircularProgress from "@material-ui/core/CircularProgress";
import { LoadingSkeletons } from "../../../components";
import { ContractService } from "../../../service";
import { withTranslation } from "react-i18next";
import { compose } from "redux";
import { EnergyTooltip, ChartWrapper } from "./index";
import MenuItem from "@material-ui/core/MenuItem";
import Menu from "@material-ui/core/Menu";
import { ResponsiveContextConsumer } from '../../../contexts';
import Fab from "@material-ui/core/Fab";
import Color from "color";
import Settings from "../../../settings.yml";
import moment from 'moment';
import "moment/min/locales";


const styles = theme => ({
  root: {
    margin: theme.spacing(2, 0, 2, 0)
  },
  text: {
    padding: theme.spacing(1, 1, 0),
  },
  button: {
    margin: theme.spacing(1),
  },
  inputVizForm: {
    margin: theme.spacing(1),
    minWidth: 150
  },
  flexCenter: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  chartContainer: {
    // margin: theme.spacing(5),
  },
  downloadCCHMenu: {
    border: '1px solid #d3d4d5',
  }
});

const NavigationLeftDayRangeIcon = () => (
  <div
    style={{
      backgroundColor: Color(theme.palette.secondary.main).fade(0.9).rgb().string(),
      left: '22px',
      borderRadius: '200px 200px 200px 200px',
      position: 'absolute',
      top: '10px',
      border: `1px solid ${theme.palette.secondary.light}`,
    }}
    tabIndex="0"
  >
    <IconButton color="secondary">
       <ArrowBack />
     </IconButton>
  </div>
);

const NavigationRightDayRangeIcon = () => (
  <div
    style={{
      backgroundColor: Color(theme.palette.secondary.main).fade(0.9).rgb().string(),
      right: '22px',
      borderRadius: '200px 200px 200px 200px',
      position: 'absolute',
      top: '10px',
      border: `1px solid ${theme.palette.secondary.light}`,
    }}
    tabIndex="0"
  >
    <IconButton color="secondary" variant="outlined">
       <ArrowForward />
     </IconButton>
  </div>
);

class ContractCCH extends React.Component {
  constructor(props) {
    super(props);

    this.contractService = new ContractService();
    this.state = {
      focusedInput: null,
      startDate: moment().subtract(1, 'year'),
      endDate: moment(),
      chartViz: 'monthly',
      fetchingChart: false,
      chartData: [],
      downloadingCCH: false,
      errMsg: false,
      anchorEl: null,
      locale: props.i18n.language || Settings.defaultLanguage,
    };
  }

  componentWillUnmount() {
    this.contractService.cancelRequests();
  }

  componentDidMount() {
    this.fetchChartData();
  }

  onDatesChange = ({ startDate, endDate }) => {
    this.setState({
      startDate: startDate,
      endDate: endDate,
    });
  };

  onFocusChange = (focusedInput) => {
    this.setState({ focusedInput });
  };

  onMonthChange = (monthChanged, startOrEnd) => {
    if (startOrEnd === 'start') {
      this.setState({
        startDate: monthChanged
      });
    } else {
      this.setState({
        endDate: monthChanged
      });
    }
  };

  isDataPresent() {
    return !this.state.fetchingChart && !_.isEmpty(this.state.chartData);
  }

  renderResponsiveChart(responsiveData) {
    const { chartData, chartViz, startDate, endDate } = this.state;
    const chartType = chartViz === 'monthly' ? "bar" : "area";
    let aspect = 1.85;
    if (responsiveData.device === 'mobile')
      aspect *= 0.6
    else if (responsiveData.device === 'tablet')
      aspect *= 0.8
    if (chartType === 'area') {
      aspect *= 0.9
    }
    const margin = {
      top: 50,
      right: responsiveData.device === 'mobile' ? 5 : 50,
      bottom: 50,
      left: responsiveData.device === 'mobile' ? 5 : 50,
    }
    return <ChartWrapper
      chartData={chartData}
      chartType={chartType}
      customTooltip={EnergyTooltip}
      descriptor={"date"}
      series={[
        {
          key: "active_import",
          label: `${this.props.t('consumed')} (kWh)`
        }, {
          key: "active_export",
          label: `${this.props.t('poured')} (kWh)`
        }
      ]}
      yAxisTickFormatter={
        (consume) => round(consume, 2).toString().replace('.', ',')
      }
      xAxisTickFormatter={
        (date) => returnDescriptiveDate(date)
      }
      aspect={aspect}
      width={"99%"}
      margin={margin}
      startDate={startDate} endDate={endDate}
    />
  }

  renderChart() {
    if (this.state.fetchingChart) {
      return <LoadingSkeletons fullHeight style={{marginTop: "15%"}}/>
    }
    else if (this.isDataPresent()){
      return (
        <ResponsiveContextConsumer>
          {
            value => this.renderResponsiveChart(value)
          }
        </ResponsiveContextConsumer>
      );
    }
    else if (!this.isDataPresent()) {
      return (
        <Grid container alignItems="center" justify="center" direction="column" style={{width: "100%", height: "100%", marginTop: "15%"}}>
          <svg height="64pt" viewBox="0 0 512.00037 512" width="64pt" xmlns="http://www.w3.org/2000/svg"><g fillRule="evenodd"><path d="m248.953125 61.273438c-5.367187-1.238282-10.722656 2.101562-11.964844 7.46875-1.242187 5.367187 2.105469 10.726562 7.472657 11.96875 24.8125 5.734374 47.492187 18.332031 65.582031 36.421874 53.183593 53.183594 53.183593 139.726563 0 192.910157-53.183594 53.1875-139.726563 53.1875-192.910157 0-53.1875-53.183594-53.1875-139.726563 0-192.910157 15.269532-15.269531 33.339844-26.40625 53.710938-33.109374 5.230469-1.71875 8.078125-7.355469 6.359375-12.589844-1.722656-5.234375-7.363281-8.082032-12.59375-6.359375-23.367187 7.683593-44.085937 20.453125-61.582031 37.953125-60.964844 60.964844-60.964844 160.160156 0 221.125 30.480468 30.480468 70.519531 45.722656 110.5625 45.722656 40.039062-.003906 80.078125-15.242188 110.5625-45.722656 60.960937-60.964844 60.960937-160.160156 0-221.125-20.738282-20.734375-46.738282-35.175782-75.199219-41.753906zm0 0"/><path d="m498.414062 432.707031-104.53125-104.53125c53.601563-84.054687 41.863282-194.484375-29.265624-265.617187-40.339844-40.339844-93.976563-62.558594-151.027344-62.558594-57.054688 0-110.691406 22.21875-151.03125 62.558594-40.34375 40.339844-62.558594 93.976562-62.558594 151.03125 0 57.050781 22.214844 110.6875 62.558594 151.027344 40.339844 40.339843 93.972656 62.554687 151.023437 62.554687 40.945313 0 80.386719-11.484375 114.59375-33.289063l104.53125 104.53125c8.746094 8.75 20.414063 13.566407 32.855469 13.566407 12.4375 0 24.105469-4.816407 32.855469-13.566407 18.109375-18.117187 18.109375-47.589843-.003907-65.707031zm-14.105468 51.601563c-4.980469 4.976562-11.636719 7.71875-18.746094 7.71875-7.113281 0-13.769531-2.742188-18.75-7.71875l-110.304688-110.304688c-1.929687-1.933594-4.484374-2.921875-7.054687-2.921875-1.976563 0-3.960937.582031-5.683594 1.777344-32.410156 22.480469-70.515625 34.363281-110.1875 34.363281-51.722656 0-100.347656-20.140625-136.917969-56.710937-75.5-75.5-75.5-198.347657 0-273.847657 36.574219-36.574218 85.199219-56.714843 136.925782-56.714843 51.722656 0 100.347656 20.140625 136.921875 56.714843 66.28125 66.285157 75.683593 170.207032 22.347656 247.105469-2.75 3.964844-2.269531 9.324219 1.144531 12.738281l110.304688 110.304688c10.335937 10.335938 10.335937 27.15625 0 37.496094zm0 0"/><path d="m273.804688 153.371094c-3.894532-3.894532-10.207032-3.894532-14.105469 0l-46.109375 46.109375-46.113282-46.109375c-3.894531-3.894532-10.210937-3.894532-14.105468 0-3.894532 3.894531-3.894532 10.210937 0 14.105468l46.109375 46.113282-46.109375 46.109375c-3.894532 3.894531-3.894532 10.210937 0 14.105469 1.945312 1.949218 4.5 2.921874 7.050781 2.921874 2.554687 0 5.105469-.972656 7.054687-2.921874l46.109376-46.109376 46.109374 46.109376c1.949219 1.949218 4.503907 2.921874 7.054688 2.921874 2.554688 0 5.105469-.972656 7.054688-2.921874 3.894531-3.894532 3.894531-10.210938 0-14.105469l-46.113282-46.109375 46.113282-46.113282c3.894531-3.894531 3.894531-10.210937 0-14.105468zm0 0"/><path d="m206.976562 77.328125c5.492188 0 9.972657-4.480469 9.972657-9.976563 0-5.492187-4.480469-9.972656-9.972657-9.972656-5.496093 0-9.976562 4.480469-9.976562 9.972656 0 5.496094 4.480469 9.976563 9.976562 9.976563zm0 0"/></g></svg>
          <Typography variant="h5">{this.props.t('validation:no_consumption_data')}</Typography>
        </Grid>
      )
    }
  }

  handleChange = event => {
    event.preventDefault();
    const { name, value } = event.target;
    this.setState({ [name]: value });
  };

  renderTypeSelector() {
    const { classes, t } = this.props;
    return (
      <FormControl variant="outlined" className={classes.inputVizForm} fullWidth>
        <InputLabel htmlFor="chart-type-select">{t('visualization')}</InputLabel>
        <Select
          native
          value={this.state.chartViz}
          onChange={this.handleChange}
          label={t('visualization')}
          inputProps={{
            name: 'chartViz',
            id: 'chart-type-select',
          }}
        >
          <option value={"monthly"}>{t("monthly")}</option>
          <option value={"daily"}>{t("daily")}</option>
          <option value={"hourly"}>{t("hourly")}</option>
        </Select>
      </FormControl>
    )
  }

  renderDatePresets = () => {
    function isSameDay(a, b) {
      if (!moment.isMoment(a) || !moment.isMoment(b))
        return false;
      return a.date() === b.date() &&
        a.month() === b.month() &&
        a.year() === b.year();
    }

    const { classes, t } = this.props;
    const { startDate, endDate } = this.state;

    const today = moment();
    const yesterday = moment().subtract(1, 'day');
    const presets = [
      {
        text: t('yesterday'),
        start: yesterday,
        end: yesterday,
      },
      {
        text: t('last_week'),
        start: moment().subtract(1, 'week'),
        end: today,
      },
      {
        text: t('last_month'),
        start: moment().subtract(1, 'month'),
        end: today,
      }
    ];

    return (
      <div>
        {presets.map(({ text, start, end }) => {
          const isSelected = isSameDay(start, startDate) && isSameDay(end, endDate);
          return (
            <Button
              variant="contained"
              disableElevation
              key={text}
              type="button"
              className={classes.button}
              color={isSelected ? "secondary" : "default"}
              onClick={() => this.onDatesChange({
                startDate: start, endDate: end
              })}
            >
              {text}
            </Button>
          );
        })}
      </div>
    );
  };

  fetchChartData = () => {
    const { startDate, endDate, chartViz, fetchingChart } = this.state;
    if ((startDate && endDate) && !fetchingChart) {
      let chartStart = startDate;
      let chartEnd = endDate;
      if (chartViz === 'monthly') {
        chartStart = moment(startDate).subtract(1, 'month').endOf('month');
        chartEnd = moment(endDate).add(1, 'month').startOf('month');
      }

      const { contract } = this.props;
      this.setState({
        chartData: [],
        fetchingChart: true,
      });

      /* Move this to Actions&Reducers */
      this.contractService.getChartData(
        contract.name, chartStart.toISOString(), chartEnd.toISOString(), chartViz
      )
      .then(
        chartData => {
          this.setState({
            chartData: chartData,
            fetchingChart: false,
          });
        }
      );
    }
  };

  getMinMaxDates() {
    const { chartViz, endDate } = this.state;

    let maxDays = 365 * 4;
    if (chartViz === 'hourly') {
      maxDays = 60;
    } else if (chartViz === 'daily') {
      maxDays = 365;
    }
    const minDate = moment(endDate).subtract(maxDays, 'days').startOf('month');
    return [ minDate, endDate ];
  }

  getDatePickerProps(device) {
    const { t } = this.props;
    return {
      startDateId: 'startDate',
      startDatePlaceholderText: t('date_start', {date: t('date')}),
      endDateId: 'endDate',
      endDatePlaceholderText: t('date_end', {date: t('date')}),
      showClearDates: true,
      openDirection: 'down',
      orientation: 'horizontal',
      anchorDirection: 'left',
      daySize: device === 'mobile' ? 40 : 50,
      initialVisibleMonth: () => moment().subtract(1, 'months'),
      numberOfMonths: device === 'mobile' ? 1 : 2,
      keepOpenOnDateSelect: false,
      navPrev: <NavigationLeftDayRangeIcon/>,
      navNext: <NavigationRightDayRangeIcon/>,
      noBorder: false,
      calendarInfoPosition: "bottom",
      enableOutsideDays: true,
      isDayBlocked: () => false,
      isOutsideRange: day => false,
      isDayHighlighted: () => false,
      transitionDuration: 0,
    }
  }

  renderDatePicker(device) {
    const { startDate, endDate, focusedInput, chartViz } = this.state;
    const { t } = this.props;
    if (chartViz && (chartViz === 'daily' || chartViz === 'hourly')) {
      return (
        <DateRangePicker
        {...this.getDatePickerProps(device)}
        renderCalendarInfo={this.renderDatePresets}
        onDatesChange={this.onDatesChange}
        onFocusChange={this.onFocusChange}
        startDate={startDate}
        endDate={endDate}
        focusedInput={focusedInput}
        />
        )
      }
      else if (chartViz && chartViz === 'monthly') {
        const [ minDate, maxDate ] = this.getMinMaxDates(this.state.chartViz);
      return (
        <MuiPickersUtilsProvider utils={MomentUtils} locale={this.state.locale}>
          <DatePicker
            variant="inline"
            openTo="year"
            views={["year", "month"]}
            label={t('date_start', {date: t('month')})}
            value={startDate}
            minDateMessage={`${t('validation:date_must_be', {what: 'La fecha', how: "posterior a"})} ${minDate.format("MM/YYYY")}`}
            maxDateMessage={`${t('validation:date_must_be', {what: 'La fecha', how: "anterior a"})} ${maxDate.format("MM/YYYY")}`}
            onChange={(date) => {}}
            onMonthChange={(startDate) => this.onMonthChange(startDate, 'start')}
            style={{margin: theme.spacing(1)}}
            disableFuture
            inputVariant="outlined"
            autoOk
          />
          <DatePicker
            variant="inline"
            openTo="year"
            views={["year", "month"]}
            label={t('date_end', {date: t('month')})}
            value={endDate}
            minDateMessage={`${t('validation:date_must_be', {what: 'La fecha', how: "posterior a"})} ${minDate.format("MM/YYYY")}`}
            maxDateMessage={`${t('validation:date_must_be', {what: 'La fecha', how: "anterior a"})}} ${maxDate.format("MM/YYYY")}`}
            onChange={(date) => {}}
            onMonthChange={(endDate) => this.onMonthChange(endDate, 'end')}
            style={{margin: theme.spacing(1)}}
            disableFuture
            inputVariant="outlined"
            autoOk
          />
        </MuiPickersUtilsProvider>
      )
    }
  }

  downloadData = (fileFormat) => {
    const { startDate, endDate, chartData, chartViz } = this.state;
    console.log("Inici", startDate.toISOString());
    console.log("Final", endDate.toISOString());
    console.log("chartViz", chartViz);
    if (startDate && endDate && chartData){
      const { contract } = this.props;
      this.setState({downloadingCCH: true, anchorEl: null})

      this.contractService.downloadCCH(
        contract.name, startDate.toISOString(), endDate.toISOString(), fileFormat, chartViz
      )
      .then(
        response => {
          this.setState({downloadingCCH: false});
          // AXIOS has blocked access to content-disposition header
          // const filename = response.headers["content-disposition"].split("=");

          const filename = `CCH_${startDate.format('DD-MM-YYYY')}_${endDate.format('DD-MM-YYYY')}.${fileFormat}`;
          saveAs(response.data, filename);
        }
      ).catch(
        error => {
          console.debug("Error downloading CCH", error);
          this.setState({downloadingCCH: false});
        }
      );
    }
  };

  handleDownloadMenuOpen = (event, open=true) => {
    const newAnchorEl = open ? event.currentTarget : null;
    this.setState({anchorEl: newAnchorEl});
  }

  render() {
    const { classes, t } = this.props;
    const { downloadingCCH, anchorEl } = this.state;
    return (
      <Grid container item xs={12} className={classes.root}>
        <Grid item xs={12} md={6}>
          <Typography variant="body1" style={{padding: '.5em'}}>
            {t('select_visualization_msg')}
          </Typography>
        </Grid>
        <Grid
          item container xs={12}
          className={classes.flexCenter}
          style={{
            paddingTop: theme.spacing(2),
            zIndex: 1101,
          }}
        >
          <Grid item xs={12} md={3} className={classes.flexCenter}>
            {this.renderTypeSelector()}
          </Grid>
          <Grid item xs={12} md={5} className={classes.flexCenter}>
            <ResponsiveContextConsumer>
              {({ device }) => this.renderDatePicker(device)}
            </ResponsiveContextConsumer>
          </Grid>
          <Grid item xs={12} md={3} className={classes.flexCenter}>
            <Button
              type="button" onClick={this.fetchChartData}
              variant="contained" color="primary"
              size="large"
              fullWidth
              style={{
                margin: '1em',
                paddingLeft: theme.spacing(6),
                paddingRight: theme.spacing(6)
              }}
            >
              <Timeline style={{marginRight: theme.spacing(1)}}/>
              {t('query', {what: ''})}
            </Button>
          </Grid>
          <Grid item xs={12} className={classes.chartContainer}>
            {this.renderChart()}
          </Grid>
          {
            this.isDataPresent() &&
              <Grid
                item xs={12}
                container
                direction="row"
                justify="flex-end"
                alignItems="center"
                style={{marginTop: theme.spacing(2)}}
              >
                <Grid item xs={3}>
                  <Fab
                    aria-label="download"
                    aria-controls="download-curve-menu"
                    aria-haspopup="true"
                    variant="extended"
                    size="medium"
                    color="primary"
                    style={{
                      backgroundColor: theme.palette.primary.main,
                      color: theme.palette.primary.contrastText
                    }}
                    onClick={this.handleDownloadMenuOpen}
                    disabled={downloadingCCH}
                  >
                    {downloadingCCH ? <CircularProgress size={20}/> : <GetApp/>}
                    <ResponsiveContextConsumer>
                      {
                        values => values.device !== 'mobile' && t('download', {what: t('data', {count: 2})})
                      }
                    </ResponsiveContextConsumer>
                  </Fab>
                  <Menu
                    elevation={2}
                    getContentAnchorEl={null}
                    anchorEl={anchorEl}
                    keepMounted
                    open={Boolean(anchorEl)}
                    onClose={() => this.handleDownloadMenuOpen(false)}
                    className={classes.downloadCCHMenu}
                    transformOrigin={{
                      horizontal: 'left',
                      vertical: 'bottom',
                    }}
                  >
                    <MenuItem>
                      <Button
                        onClick={() => this.downloadData('xlsx')}
                        type="button"
                        variant="outlined"
                        color="primary"
                        disableElevation
                        startIcon={<i className="far fa-file-excel"/>}
                      >
                        {t('format', {which: 'Excel'})}
                      </Button>
                    </MenuItem>
                    <MenuItem>
                      <Button
                        onClick={() => this.downloadData('csv')}
                        type="button"
                        variant="outlined"
                        color="primary"
                        disableElevation
                        startIcon={<i className="fas fa-file-csv"/>}
                      >
                        {t('format', {which: 'CSV'})}
                      </Button>
                    </MenuItem>
                  </Menu>
                </Grid>
              </Grid>
          }
        </Grid>
      </Grid>
    )
  }
}

ContractCCH.propTypes = {
  contract: PropTypes.object
};

export default compose(
  withStyles(styles),
  withTranslation(['common', 'validation'])
)(ContractCCH);

